import $ from 'jquery';

export function activateVideo() {
    let $videoElements = $('.ce-video-content');

    $videoElements.each(function () {
        const $this = $(this);
        const $video = $this.find('video'),
            video = <HTMLVideoElement>$video[0],
            $btnPause = $this.find('.pause'),
            $btnPlay = $this.find('.play'),
            $btnFastBackward = $this.find('.fast-backward'),
            $btnVolumeUp = $this.find('.volume-up'),
            $btnVolumeDown = $this.find('.volume-down'),
            $btnFullscreen = $this.find('.fullscreen'),
            $btnAD = $this.find('.ad');

        $btnPlay.on('click', function () {
            $video.trigger('play');
        });

        $btnPause.on('click', function () {
            $video.trigger('pause');
        });

        $btnFullscreen.on('click', function () {
            const browsersFullScreenFunctions = video as HTMLVideoElement & {
                webkitRequestFullscreen(): Promise<void>;
                msRequestFullscreen(): Promise<void>;
            };

            if (browsersFullScreenFunctions.requestFullscreen) {
                browsersFullScreenFunctions.requestFullscreen();
            } else if (browsersFullScreenFunctions.webkitRequestFullscreen) {
                browsersFullScreenFunctions.webkitRequestFullscreen();
            } else if (browsersFullScreenFunctions.msRequestFullscreen) {
                browsersFullScreenFunctions.msRequestFullscreen();
            }
            return false;
        });

        $btnVolumeUp.on('click', function () {
            let vol = video.volume;
            vol += 0.1;
            if (vol > 1) {
                vol = 1
            }
            video.volume = vol;
        });

        $btnVolumeDown.on('click', function () {
            let vol = video.volume;
            vol -= 0.1;
            if (vol < 0) {
                vol = 0
            }
            video.volume = vol;
        });

        $btnFastBackward.on('click', function () {
            $video.trigger('pause');
            video.currentTime = 0;
        });

        $btnAD.on('click', function(){
            const playing = ! $video[0].paused;
            const curtime = $video[0].currentTime;
            $video.find('source').remove()
            if ( $btnAD.hasClass('btn-primary')){
                $btnAD.removeClass('btn-primary');
                $btnAD.addClass('btn-secondary');
                $video.prepend($this.find('.video.audioDescription').children().clone());
            } else {
                $btnAD.removeClass('btn-secondary');
                $btnAD.addClass('btn-primary');
                $video.prepend($this.find('.video.normal').children().clone());
            }
            $video[0].load();
            $video[0].currentTime = curtime;
            if ( playing ){
                $video[0].play();
            }
        })
    });
    
    
      const videos = document.querySelectorAll('.ce-video .ce-video-content video');
    
      videos.forEach(video => {
        const posterAttr = video.getAttribute('poster');
        if (posterAttr !== '') {
          return;
        }
        // Für CORS‐konforme Videos nötig, falls extern geladen:
        video.crossOrigin = 'anonymous';
    
        const canvas = document.createElement('canvas');
        const ctx    = canvas.getContext('2d');
    
        video.addEventListener('loadedmetadata', () => {
          canvas.width  = video.videoWidth;
          canvas.height = video.videoHeight;
          video.currentTime = 0;
        });
    
        video.addEventListener('seeked', function grabFrame() {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          const dataURL = canvas.toDataURL('image/png');
          video.setAttribute('poster', dataURL);
    
          video.removeEventListener('seeked', grabFrame);
          video.pause();
        }, { once: true });
    
        // Neu laden, damit loadedmetadata/seeked kommen
        video.load();
      });
    
    
}
